import { render, staticRenderFns } from "./copywriter.vue?vue&type=template&id=5c22f95b&scoped=true"
import script from "./copywriter.vue?vue&type=script&lang=js"
export * from "./copywriter.vue?vue&type=script&lang=js"
import style0 from "./copywriter.vue?vue&type=style&index=0&id=5c22f95b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c22f95b",
  null
  
)

export default component.exports